// Styles
require("./generic.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/generic/index.js
 ** module id = 116
 ** module chunks = 0 1
 **/